import React from 'react';

interface Props {
    className: string;
    onClick?: () => void;
}
export default class SidebarHeaderParent extends React.PureComponent<Props, {}> {
    static defaultProps = {
        className: '',
    };

    handleClick = (evt: React.MouseEvent): void => {
        const { onClick } = this.props;

        if (onClick) {
            evt.stopPropagation();
            evt.nativeEvent.stopImmediatePropagation();
            onClick();
        }
    };

    render() {
        const { children, className } = this.props;

        let classNames: Array<string> = ['ct-sidebar__header-parent'];
        if (className) {
            classNames.push(className);
        }

        return (
            <div className={classNames.join(' ')} onClick={this.handleClick}>
                {children}
            </div>
        );
    }
}
